// petpackApi.js — API del canal PetPack (comida de mascotas).
// Todo pasa por RPCs SECURITY DEFINER en public (petpack_admin_*) que exigen
// superadmin y operan sobre el schema aislado `petpack`. El schema NO está
// expuesto al Data API: esta es la única puerta, y queda auditada.
import { supabase } from './supabase'

async function rpc(fn, args) {
  const { data, error } = await supabase.rpc(fn, args)
  if (error) throw error
  return data
}

export const petpackGetProductos   = (incluirEliminados = false) => rpc('petpack_admin_productos', { p_incluir_eliminados: incluirEliminados })
export const petpackGetCategorias  = () => rpc('petpack_admin_categorias')
export const petpackGetConfig      = () => rpc('petpack_admin_get_config')
export const petpackGetMovimientos = (productoId, limit = 50) => rpc('petpack_admin_movimientos', { p_producto: productoId, p_limit: limit })
export const petpackUpsertProducto = (p) => rpc('petpack_admin_upsert_producto', { p })
export const petpackToggle         = (id, campo, valor) => rpc('petpack_admin_toggle', { p_id: id, p_campo: campo, p_valor: valor })
export const petpackBorrarProducto = (id) => rpc('petpack_admin_borrar_producto', { p_id: id })
export const petpackRestaurarProducto = (id) => rpc('petpack_admin_restaurar_producto', { p_id: id })
export const petpackAjustarStock   = (id, cantidadNueva, motivo) => rpc('petpack_admin_ajustar_stock', { p_id: id, p_cantidad_nueva: cantidadNueva, p_motivo: motivo })
export const petpackUpdateConfig   = (p) => rpc('petpack_admin_update_config', { p })

export function petpackDisponible(p) {
  return Number(p?.stock_actual || 0) - Number(p?.stock_reservado || 0)
}
